<div class="container mt-4 chart-dashboard text-dark">
  <div class="row g-4">

<div class="summary-row">
  <div *ngFor="let type of ['COCO','DODO','FULL DODO','OMC']" class="summary-card">
    <span class="card-title">No. Of Stations {{type}}</span>
    <span class="card-value">{{ getOwnershipCount(type) }}</span>
  </div>
</div>
    <!-- Station Type -->
    <div class="col-md-6 col-12">
      <div class="card shadow-sm h-100">
        <div class="card-body position-relative">
          <i class="bi bi-arrow-counterclockwise position-absolute top-0 end-0 m-2" (click)="resetMovement()"
            style="color: #007bff; font-weight: bold; font-size: 1.3rem; cursor: pointer;" title="Reset"></i>
          <h5 class="card-title text-center">Station Type Wise (Qty in KG)</h5>
          <canvas #stationChart style="width: 100%; height: 300px;"></canvas>
        </div>
      </div>
    </div>

    <!-- Ownership Type -->
    <div class="col-md-6 col-12">
      <div class="card shadow-sm h-100">
        <div class="card-body position-relative">
          <h5 class="card-title text-center">Ownership Type Wise (Qty in KG)</h5>
          <canvas #ownershipChart style="width: 100%; height: 300px;"></canvas>
        </div>
      </div>
    </div>

    <!-- Movement Type Chart 1 -->
    <div class="col-md-10 col-12 mx-auto" *ngIf="showmovementChart">
      <div class="card shadow-sm">
        <div class="card-body position-relative">
          <!-- <label class="position-absolute top-0 start-0 m-2 small text-muted">
            <strong> MovementType</strong>
          </label> -->
          <h5 class="card-title text-center">Moment Type Wise (Qty in KG)</h5>

          <canvas #movementChart style="width: 100%; height: 300px;"></canvas>
        </div>
      </div>
    </div>

    <!-- Movement Type Chart 2 -->
    <div class="col-md-12 col-12 mx-auto" *ngIf="showStationPlantWise">
      <div class="card shadow-sm">
        <div class="card-body position-relative" style="overflow-x: auto; white-space: nowrap;">
          <label class="position-absolute top-0 start-0 m-2 small text-muted">
          </label>
          <div class="chartWrapper">
            <div class="chartAreaWrapper" [style.width.%]="soldQtyplantWiseChartWidth">
              <canvas #stationTypeSoldQty height="300"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-12 mx-auto" *ngIf="showSoldQtyByDayStationType">
      <div class="card shadow-sm">
        <i class="bi bi-arrow-counterclockwise position-absolute top-0 end-0 m-2" (click)="resetPlantWise()"
          style="color: #3e63a7; font-weight: bold; font-size: 1.3rem; cursor: pointer; z-index: 4;" title="Reset"></i>
        <div class="card-body position-relative" style="overflow-x: auto; white-space: nowrap;">
          <label class="position-absolute top-0 start-0 m-2 small text-muted">
          </label>
          <div class="chartWrapper">
            <div class="chartAreaWrapper" [style.width.%]="soldQtyDayWiseChartWidth">
              <canvas #soldQtyByDayStationType height="300"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>